import { ld } from "@/lib/theme/light-dark";
import { Check, Clock } from "lucide-react";
import type { CSSProperties, ReactNode } from "react";

import { useTranslations } from "next-intl";
import { HERO_VORGANG_THREAD_PADDING_X_PX } from "./hero-vorgang-tokens";

/** Values read off the app's task footer (reply field, Wiedervorlage, Erledigt). */
const MUTED_TEXT: string = ld("rgba(15,23,42,0.4)", "rgba(250,250,250,0.4)");
const SURFACE: string = ld("#fff", "#181b1f");

const KBD_STYLE: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 18,
  height: 18,
  border: `1px solid ${ld("rgba(15,23,42,0.15)", "rgba(250,250,250,0.15)")}`,
  borderRadius: 4,
  background: "rgba(0,128,112,0.04)",
  fontSize: 10,
  fontWeight: 500,
  lineHeight: 1,
  color: MUTED_TEXT,
  flexShrink: 0,
};

const SIDE_BUTTON: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  height: 40,
  padding: "0 10px",
  borderRadius: 6,
  background: SURFACE,
  fontSize: 12,
  fontWeight: 500,
  color: MUTED_TEXT,
  whiteSpace: "nowrap",
  flexShrink: 0,
};

function ShortcutKey(props: { readonly children: string }): ReactNode {
  return <span style={KBD_STYLE}>{props.children}</span>;
}

export function HeroVorgangActionFooter(): ReactNode {
  const t = useTranslations("marketing.heroVorgangActionFooter");
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        padding: `8px ${HERO_VORGANG_THREAD_PADDING_X_PX}px 12px`,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 6,
          height: 40,
          padding: "0 14px",
          borderRadius: 8,
          border: `1px solid ${ld("rgba(15,23,42,0.1)", "rgba(250,250,250,0.1)")}`,
          background: SURFACE,
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          fontSize: 13,
          color: MUTED_TEXT,
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        <ShortcutKey>{t("a")}</ShortcutKey>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
          {t("antworten")}
        </span>
      </div>

      <span style={SIDE_BUTTON}>
        <span style={{ color: "#D97706", display: "inline-flex" }}>
          <Clock width={14} height={14} strokeWidth={1.9} />
        </span>
        {t("wiedervorlage")}
        <ShortcutKey>{t("w")}</ShortcutKey>
      </span>

      <span style={SIDE_BUTTON}>
        <Check width={14} height={14} strokeWidth={2} />
        {t("erledigt")}
        <ShortcutKey>{t("e")}</ShortcutKey>
      </span>
    </div>
  );
}
